"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolsService = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const store_1 = require("@completeanatomy/store");
require("reflect-metadata");
const typedi_1 = require("typedi");
const constants_1 = require("../components/constants");
const LabelToolManager_1 = require("./managers/LabelToolManager");
const PenToolManager_1 = require("./managers/PenToolManager");
const StickiesToolManager_1 = require("./managers/StickiesToolManager");
const ThreeDToolsManager_1 = require("./managers/ThreeDToolsManager");
let ToolsService = class ToolsService {
    constructor(bridge, toolsState, toolsOptions, deviceInfo) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        this.bridge = bridge;
        this.toolsState = toolsState;
        this.toolsOptions = toolsOptions;
        this.deviceInfo = deviceInfo;
        this.penToolManager = new PenToolManager_1.PenToolManager(toolsState, toolsOptions, bridge);
        this.stickiesToolManager = new StickiesToolManager_1.StickiesToolManager(toolsState, toolsOptions, bridge);
        this.labelToolManager = new LabelToolManager_1.LabelToolManager(toolsState, bridge);
        this.threeDToolsManager = new ThreeDToolsManager_1.ThreeDToolsManager(toolsOptions, bridge);
        // @ts-ignore
        (_b = (_a = window === null || window === void 0 ? void 0 : window.Utils) === null || _a === void 0 ? void 0 : _a.EventEmitter) === null || _b === void 0 ? void 0 : _b.on('ToolkitRestoreNotification', 
        // @ts-ignore
        ({ userInfo }) => this.setToolkitState(userInfo));
        // @ts-ignore
        (_d = (_c = window === null || window === void 0 ? void 0 : window.Utils) === null || _c === void 0 ? void 0 : _c.EventEmitter) === null || _d === void 0 ? void 0 : _d.on('WOLControllerRestoreLabels', 
        // @ts-ignore
        ({ userInfo }) => this.setToolkitState({ labelManagerState: userInfo.options }));
        // @ts-ignore
        (_f = (_e = window === null || window === void 0 ? void 0 : window.Utils) === null || _e === void 0 ? void 0 : _e.EventEmitter) === null || _f === void 0 ? void 0 : _f.on('ToolkitClearToolNotification', 
        // @ts-ignore
        ({ userInfo }) => this.clearTools(userInfo.type));
        // @ts-ignore
        (_h = (_g = window === null || window === void 0 ? void 0 : window.Utils) === null || _g === void 0 ? void 0 : _g.EventEmitter) === null || _h === void 0 ? void 0 : _h.on('ToolkitClearAllNotification', () => this.clearTools());
        // @ts-ignore
        (_k = (_j = window === null || window === void 0 ? void 0 : window.Utils) === null || _j === void 0 ? void 0 : _j.EventEmitter) === null || _k === void 0 ? void 0 : _k.on('WOLControllerDidUpdateLabels', (notification) => {
            const updatedData = notification.userInfo.options;
            updatedData.forEach((data) => {
                this.labelToolManager.updateLabelTarget(data.identifier, data.position);
                if (data.targetObjects) {
                    this.labelToolManager.updateLabelPartsTarget(data.identifier, data.targetObjects.map((object) => ({
                        identifier: object.identifier,
                        target: object.position,
                    })));
                }
            });
        });
        // @ts-ignore
        (_m = (_l = window === null || window === void 0 ? void 0 : window.Utils) === null || _l === void 0 ? void 0 : _l.EventEmitter) === null || _m === void 0 ? void 0 : _m.on('WOLControllerPrepareToUpdateLabels', () => {
            const labels = this.labelToolManager.getLabelsState();
            if (!labels.length) {
                return;
            }
            this.bridge.updateLabelPositions({
                state: labels,
                tool: bridge_schema_1.ToolType.Labels,
            });
        });
        // @ts-ignore
        (_p = (_o = window === null || window === void 0 ? void 0 : window.Utils) === null || _o === void 0 ? void 0 : _o.EventEmitter) === null || _p === void 0 ? void 0 : _p.on('WOLControllerUnfocusLabelManager', () => {
            this.labelToolManager.deselectLabel();
        });
        // @ts-ignore
        (_r = (_q = window === null || window === void 0 ? void 0 : window.Utils) === null || _q === void 0 ? void 0 : _q.EventEmitter) === null || _r === void 0 ? void 0 : _r.on('WOLStickyManagerNewStickyNotification', ({ userInfo }) => {
            var _a;
            // check bundle on unlimited video size
            const isVideoStickyUnlimited = (_a = window.Manager) === null || _a === void 0 ? void 0 : _a.AccountManager.isVideoStickyUnlimited;
            const isTouchDevice = window.isTouchDevice();
            if (userInfo.type === bridge_schema_1.ToolType.StickyVideo &&
                !isVideoStickyUnlimited &&
                !isTouchDevice &&
                (userInfo.videoSize > constants_1.MAX_VIDEO_STICKY_SIZE ||
                    parseInt(userInfo.duration) > constants_1.MAX_VIDEO_STICKY_DURATION)) {
                // @ts-ignore
                window.AppShell.AppRouter.navigate('/tools/video-hint');
                return;
            }
            const defaultY = 100;
            const defaultX = 200 +
                (document.body.offsetWidth - (document.body.offsetHeight / 3) * 4) /
                    2;
            const stickyWidth = userInfo.type === bridge_schema_1.ToolType.StickyImage
                ? userInfo.imageSize[0]
                : userInfo.videoSize[0];
            const stickyHeight = userInfo.type === bridge_schema_1.ToolType.StickyImage
                ? userInfo.imageSize[1]
                : userInfo.videoSize[1];
            const image = userInfo.type === bridge_schema_1.ToolType.StickyImage
                ? userInfo === null || userInfo === void 0 ? void 0 : userInfo.image
                : userInfo === null || userInfo === void 0 ? void 0 : userInfo.thumb;
            const newSticky = [
                {
                    identifier: Math.round(Math.random() * 10e6).toString(), //NOSONAR
                    stickyRect: {
                        x: defaultX,
                        y: defaultY,
                        width: 230,
                        height: (stickyHeight * 230) / stickyWidth,
                    },
                    text: '',
                    curves: [],
                    image,
                    videoLink: userInfo.data,
                    type: userInfo.type,
                },
            ];
            this.addSticky(newSticky);
        });
    }
    getPenToolManager() {
        return this.penToolManager;
    }
    getStickiesToolManager() {
        return this.stickiesToolManager;
    }
    getLabelToolManager() {
        return this.labelToolManager;
    }
    getThreeDToolManager() {
        return this.threeDToolsManager;
    }
    update2DPenState(curves) {
        this.penToolManager.update2DPenState(curves);
    }
    addSticky(stickies) {
        this.stickiesToolManager.addSticky(stickies);
    }
    updateSticky(options) {
        this.stickiesToolManager.updateSticky(options);
    }
    removeSticky(identifier) {
        this.stickiesToolManager.removeSticky(identifier);
    }
    addLabel(newLabel) {
        this.labelToolManager.addLabel(newLabel);
    }
    updateLabelPosition(identifier, newPosition) {
        this.labelToolManager.updateLabelPosition(identifier, newPosition);
    }
    removeLabel(identifier) {
        this.labelToolManager.removeLabel(identifier);
    }
    resetGroupMode() {
        this.labelToolManager.resetGroupMode();
    }
    getToolkitState() {
        return {
            labelManagerState: this.labelToolManager.getLabelsState(),
            paintManagerState: {
                drawer2DCurrentState: this.penToolManager.get2DPenState(),
            },
            savedStickiesArray: this.stickiesToolManager.getStickiesState(),
        };
    }
    setToolkitState(state) {
        if (state.labelManagerState) {
            this.labelToolManager.setLabelsState(state.labelManagerState);
        }
        if (state.drawer2DCurrentState) {
            this.penToolManager.set2DPenState(state.drawer2DCurrentState);
        }
        if (state.savedStickiesArray) {
            this.stickiesToolManager.setStickiesState(state.savedStickiesArray);
        }
        if (Object.keys(state).length === 0) {
            this.labelToolManager.setLabelsState([]);
            this.penToolManager.set2DPenState([]);
            this.stickiesToolManager.setStickiesState([]);
        }
    }
    clearTools(type) {
        if (type === undefined || type === null) {
            this.setToolkitState({});
            this.labelToolManager.clearLastAddedLabel();
            return;
        }
        switch (type) {
            case bridge_schema_1.ToolType.Pen2D:
                this.penToolManager.update2DPenState([]);
                break;
            case bridge_schema_1.ToolType.StickyText:
            case bridge_schema_1.ToolType.StickyHandWriting:
            case bridge_schema_1.ToolType.StickyImage:
            case bridge_schema_1.ToolType.StickyVideo:
                this.stickiesToolManager.clearStickiesByType(type);
                break;
            case bridge_schema_1.ToolType.Labels:
            case bridge_schema_1.ToolType.LabelsLeft:
            case bridge_schema_1.ToolType.LabelsRight:
                this.labelToolManager.setLabelsState([]);
                this.labelToolManager.clearLastAddedLabel();
                break;
            default:
                break;
        }
    }
    removePartFromGroupLabel(labelIdentifier, partIdentifier) {
        this.labelToolManager.removePartFromGroupLabel(labelIdentifier, partIdentifier);
    }
    updateGrowthOptions(options) {
        this.threeDToolsManager.updateGrowthOptions(options);
    }
    updateSpursOptions(options) {
        this.threeDToolsManager.updateSpursOptions(options);
    }
    updateCutOptions(options) {
        this.threeDToolsManager.updateCutOptions(options);
    }
    updatePainOptions(options) {
        this.threeDToolsManager.updatePainOptions(options);
    }
    updateFractureOptions(options) {
        this.threeDToolsManager.updateFractureOptions(options);
    }
    updateSketchOptions(options) {
        this.stickiesToolManager.updateSketchOptions(options);
    }
    hideAnnotations() {
        this.toolsState.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'hideAnnotations',
                changes: true,
            },
        });
    }
    showAnnotations() {
        this.toolsState.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'hideAnnotations',
                changes: false,
            },
        });
    }
    hideLabels() {
        this.toolsState.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'hideLabels',
                changes: true,
            },
        });
    }
    showLabels() {
        this.toolsState.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'hideLabels',
                changes: false,
            },
        });
    }
};
exports.ToolsService = ToolsService;
ToolsService.exportName = 'tools';
exports.ToolsService = ToolsService = __decorate([
    (0, typedi_1.Service)(),
    __param(1, (0, store_1.InjectStore)('toolsState')),
    __param(2, (0, store_1.InjectStore)('toolsOptions')),
    __param(3, (0, store_1.InjectStore)('deviceInformation')),
    __metadata("design:paramtypes", [bridge_schema_1.BridgeInterface,
        store_1.InjectedStore,
        store_1.InjectedStore,
        store_1.InjectedStore])
], ToolsService);
